import backEnd from "../constants/backEnd";
import api from "../services/api";

const checkbot = async () =>{
    try {
        let result = await api.get(`${backEnd.url}bot/`)
        if (result.data?.message !== 'ACTIVATE'){
            api.post(`${backEnd.url}bot/`)
        }
    } catch (error) {
        console.log('Bot check skipped (API not available)');
    }
}

export default checkbot